import styled from 'styled-components';
const AnalyseStyled = styled.div`
  /* overflow-x: hidden; */
  .footer {
    height: 90px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin: 24px 0;
    display: flex;
    align-items: center;
    padding-left: 24px;
  }
`;
export default AnalyseStyled;
